<form novalidate (ngSubmit)="submit()" [class.submitted]="formSubmitted()">
  <div class="card-fields">
    <app-input-field
      [noError]="true"
      class="headless no-border-radius-bottom"
      data-test-id="card-number"
      [class.has-cards]="cardBrand() === 'unknown'"
      [class.elevated]="cardNumberFocused() || cardNumberError()"
    >
      <div
        id="cardnumber"
        fake-input
        [class.focus]="cardNumberFocused()"
        [class.active]="!cardNumberEmpty()"
        class="no-control"
        [class.ng-invalid]="cardNumberError()"
      ></div>
      <label>Card number</label>
      <div *appInputPost class="cards">
        @if (['unknown', 'visa'].includes(cardBrand())) {
          <img src="/assets/icons/cards/visa.svg" alt="" />
        } @else if (['unknown', 'amex'].includes(cardBrand())) {
          <img src="/assets/icons/cards/amex.svg" alt="" />
        } @else if (['unknown', 'mastercard'].includes(cardBrand())) {
          <img src="/assets/icons/cards/mastercard.svg" alt="" />
        } @else if (['discover'].includes(cardBrand())) {
          <img src="/assets/icons/cards/discover.svg" alt="" />
        } @else if (['diners'].includes(cardBrand())) {
          <img src="/assets/icons/cards/diners.svg" alt="" />
        }
      </div>
    </app-input-field>
    <app-input-field
      [noError]="true"
      class="headless no-border-radius-top no-border-radius-right"
      data-test-id="expiry"
      [class.elevated]="cardExpiryFocused() || cardExpiryError()"
    >
      <div
        id="cardexpiry"
        fake-input
        [class.focus]="cardExpiryFocused()"
        [class.active]="!cardExpiryEmpty()"
        class="no-control"
        [class.ng-invalid]="cardExpiryError()"
      ></div>
      <label>MM / YY</label>
    </app-input-field>
    <app-input-field
      [noError]="true"
      class="headless no-border-radius-top no-border-radius-left"
      data-test-id="cvc"
      [class.elevated]="cardCvcFocused() || cardCvcError()"
    >
      <div
        id="cardcvc"
        fake-input
        [class.focus]="cardCvcFocused()"
        [class.active]="!cardCvcEmpty()"
        class="no-control"
        [class.ng-invalid]="cardCvcError()"
      ></div>
      <label>CVC</label>
    </app-input-field>
  </div>
  @if ((cardCvcError() || cardExpiryError() || cardNumberError()) && formSubmitted()) {
    <div class="card-error" [class.error-spacing]="showErrorSpacing">
      <app-svg src="/assets/icons/alert-circle.svg"></app-svg>
      @if (cardNumberError()) {
        <span>{{ cardNumberError() }}</span>
      } @else if (cardExpiryError()) {
        <span>{{ cardExpiryError() }}</span>
      } @else if (cardCvcError()) {
        <span>{{ cardCvcError() }}</span>
      }
    </div>
  }
</form>
